import React, { useContext, useState } from "react";
import "./styles.css"; // Make sure to create this file and import your styles
import { CustonInput } from "../CustonInput";
import { CustomSelect } from "../CustomSelect";
import { quoteContext } from "../../context/quotesContext";
import { Modal } from "../ModalDimensions";
import box from "../../../public/assets/boxDimensions.png";
import boxEs from "../../../public/assets/boxDimensionsEs.png";
import rulseBlack from "../../../public/assets/icon/rulseBlack.png";
import ruleIcon from "../../../public/assets/icon/ruleIcon.png";
import { useTranslation } from "react-i18next";

const ShipmentForm = () => {
  const [t, i18n] = useTranslation();
  const [openModal, setOpenModal] = useState(false);
  const {
    weight,
    setWeight,
    value,
    setValue,
    dimensions,
    setDimensions,
    weightType,
    setWeightType,
    dimensionsType,
    setDimensionsType,
    getLenguaje
  } = useContext(quoteContext);


  return (
    <div className="shipment-form">
      <h1 className="title-shipment"> {t('tell_more_about_us')}</h1>
      <p className="description-shipment">
        {t('tell_more_about_us')}
        {t('please_enter_the_size')}
        <a className="guide-link" onClick={() => setOpenModal(true)}>
          {" "}
          <img className="ruleicon" src={ruleIcon} />
          {t('measurement_guide')}
        </a>
        .
      </p>
      <div className="image-container">
        <img src={getLenguaje() == 'es' ? boxEs: box } alt="Shipment Box" className="shipment-image" />
      </div>
      <div className="dimensions">
        <div className="dimensions-header">
          <div className="first-circle">
            <div className="second-circle">
              <img src={rulseBlack} />
            </div>
          </div>
          <h2 className="dimensions-header-title">
            {t('dimensions')}
          </h2>
        </div>

        <form className="dimensions-form">
          <div className="dimensions-row">
            <div className="dimensions-type">
              <CustomSelect
                label={t('measurement_format')}
                value={dimensionsType}
                placeholder={t('select')}
                className="select-container-width"
                onSelect={(e) => setDimensionsType(e)}
                haslist={true}
                options={[
                  { id: 1, label: t('centimeters') },
                  { id: 2, label: t('inches')},
                ]}
              ></CustomSelect>
            </div>
            <div className="dimensions-field long leftBorder ">
              <CustonInput
                type="number"
                name="input-long"
                label={t('long')}
                placeholder={0}
                disabled={!dimensionsType?.id}
                value={dimensions.long}
                onChange={(value) =>
                  setDimensions({
                    ...dimensions,
                    long:value >0?Number(value):'',
                  })
                }
                className="widthFull withOutBorder backgroundWhite long"
                autoComplete="off"
              ></CustonInput>
            </div>
          </div>
          <div className="dimensions-field broad leftBorder ">
              <CustonInput
                label={t('broad')}
                type="number"
                placeholder={0}
                disabled={!dimensionsType?.id}
                value={dimensions.broad}
                onChange={(value) =>
                  setDimensions({
                    ...dimensions,
                    broad: value >0?Number(value):'',
                  })
                }
                className="widthFull withOutBorder backgroundWhite"
                autoComplete="off"
              ></CustonInput>
            </div>
          <div className="dimensions-row">
            <div className="dimensions-field high leftBorder ">
              <CustonInput
                label={t('high')}
                type="number"
                placeholder={0}
                disabled={!dimensionsType?.id}
                value={dimensions.height}
                onChange={(value) =>
                  setDimensions({
                    ...dimensions,
                    height: value >0?Number(value):'',
                  })
                }
                className="widthFull withOutBorder backgroundWhite"
                autoComplete="off"
              ></CustonInput>
            </div>
     
          </div>
        </form>
      </div>
      <div className="select-divisor"></div>
      <div className="weight-value">
        <div className="Weight-container">
          <CustomSelect
            value={weightType}
            className="weight"
            placeholder={t('select')}
            onSelect={setWeightType}
            haslist={true}
            options={[
              { id: 2, label: "Kg" },
              { id: 1, label: "Lb" },
            ]}
          ></CustomSelect>
          <CustonInput
            type="number"
            label={t('weight')}
            placeholder="0"
            disabled={!weightType?.id}
            value={weight}
            className="withOutBorder weight-input backgroundWhite"
            onChange={setWeight}
            autoComplete="off"
          ></CustonInput>
        </div>
        <CustonInput
          type="number"
          label={t('value_of_the_merchandise')}
          placeholder="0 USD"
          disabled={!weightType?.id}
          className="merchandise-value backgroundWhite"
          onChange={setValue}
          value={value}
          isCurrency
          autoComplete="off"
        ></CustonInput>
      </div>
      <Modal
        show={openModal}
        handleClose={() => {
          setOpenModal(false);
        }}
      ></Modal>
    </div>
  );
};

export { ShipmentForm };
